import type { Zone } from '@bratva/content';
import { blockRect, createGrid, type Grid } from '@bratva/rules';

/** Сетка проходимости строится из футпринтов объектов — один источник правды. */
export function buildGrid(zone: Zone): Grid {
  const grid = createGrid(zone.size.width, zone.size.height);
  for (const obj of zone.objects) {
    // Лавочка и мусорка не перекрывают проход целиком, но обходить их надо.
    blockRect(grid, obj.x, obj.y, obj.w, obj.h);
  }
  return grid;
}
